import Chip from '@shared/components/chips';
import { EvidenceStatuses } from '../../../constants/chips/evidence-status.constants';
import { FilterTypes } from '@shared/components/advanced-filters/filter-types';
import { html } from '@shared/utils/rendering/html';
import { Ratings } from '../../../constants/chips/ratings.constants';
import { ComponentStatuses } from '../../../constants/chips/component-status.constants';
import { Owners } from '../../../constants/owner.constants';
import { Frequencies } from '../../../constants/frequency.constants';

export const EvidenceApproachSearchOptions = [
    { value: 0, text: 'All' },
    { value: 1, text: 'ID' },
    { value: 2, text: 'Name' },
    { value: 3, text: 'Description' },
    { value: 4, text: 'Criteria ID' },
    { value: 5, text: 'Criteria Name' },
];

export const EvidenceApproachFilterGroups = {
    componentStatusIds: 'componentStatusIds',
    subcomponentStatusIds: 'statusId',
    subcomponentRatings: 'ratingId',
    subcomponentOwners: 'ownerIds',
    subcomponentFrequencies: 'frequencyIds',
};

export const EvidenceApproachFilterDefaults = {
    selectedFilters: {}, // This is important
    defaultSearchOption: { value: 0, text: 'All' },
    filters: [
        {
            label: 'Component Status',
            identifier: EvidenceApproachFilterGroups.componentStatusIds,
            display: true,
            multiple: true,
            type: FilterTypes.STATIC_SELECT.id,
            // The chip is embedded directly in each option's `text` (matching ERM-Portal's
            // pattern in users-table.filters.js) rather than relying on `transformer`. Venus's
            // Dropdown only applies `settings.transformer` to the open option list — the
            // closed/selected display falls back to `selectedTransformer`, which
            // StaticSelectFilter never wires up, so a `transformer`-only chip disappears once
            // selected. Baking the Chip into `text` means every render path (open list, single-
            // select display, multi-select fallback chips) shows the same styled chip.
            options: Object.values(ComponentStatuses).map((status) => {
                return {
                    value: status.value,
                    text: html`<${Chip}
                        type="status-chip"
                        label=${status.label}
                        css=${status.css}
                    />`,
                    css: status.css,
                };
            }),
        },
        {
            label: 'Subcomponent Status',
            identifier: EvidenceApproachFilterGroups.subcomponentStatusIds,
            display: true,
            multiple: true,
            type: FilterTypes.STATIC_SELECT.id,
            options: Object.values(EvidenceStatuses).map((status) => {
                return {
                    value: status.value,
                    text: html`<${Chip}
                        type="status-chip"
                        label=${status.label}
                        css=${status.css}
                    />`,
                    css: status.css,
                };
            }),
        },
        {
            label: 'Evidence Ratings',
            identifier: EvidenceApproachFilterGroups.subcomponentRatings,
            display: true,
            multiple: true,
            type: FilterTypes.STATIC_SELECT.id,
            options: Object.values(Ratings).map((rating) => {
                return {
                    value: rating.value,
                    text: html`<${Chip}
                        type="indicator-chip"
                        label=${rating.label}
                        css=${rating.css}
                    />`,
                    css: rating.css,
                };
            }),
        },
        {
            label: 'Owners',
            identifier: EvidenceApproachFilterGroups.subcomponentOwners,
            display: true,
            multiple: true,
            type: FilterTypes.STATIC_SELECT.id,
            options: Object.values(Owners).map((owner) => {
                return {
                    value: owner.value,
                    text: owner.text,
                };
            }),
        },
        {
            label: 'Approval Period',
            identifier: EvidenceApproachFilterGroups.subcomponentFrequencies,
            display: true,
            multiple: true,
            type: FilterTypes.STATIC_SELECT.id,
            options: Object.values(Frequencies).map((frequency) => {
                return {
                    value: frequency.value,
                    text: frequency.text,
                };
            }),
        },
    ],
};
